<template>
  <div>
    <h1 class="main-header">
      <translate translate-context="email_schedules">Create Email Schedule</translate>
    </h1>

    <CCard>
      <CCardHeader>
        <div class="card-header-actions">
          <CButton color="primary" @click="onClickSave">
            <translate translate-context="form">Save</translate>
          </CButton>
        </div>
      </CCardHeader>
      <CCardBody>
        <EmailScheduleForm ref="form" :data="empty" @save="onSave"/>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EmailScheduleForm from './components/EmailScheduleForm.vue'
import { SuccessNotification } from '@/domain/core/exception/exceptions'

export default {
  name: 'NewEmailSchedule',
  components: {
    EmailScheduleForm
  },
  data() {
    return {
      empty: {
        job_type: '',
        schedule_from: null,
        schedule_to: null,
        send_time: '14:00',
        send_every: null,
        job_parameters: {}
      }
    }
  },
  computed: {
    ...mapGetters('emailSchedules', ['scope']),

    scopeType() {
      return this.$route.meta.scopeType || 'global'
    },

    scopeId() {
      if (this.scopeType === 'pica-service') {
        return this.$route.params.picaServiceId
      }
      if (this.scopeType === 'contract-manager') {
        return this.$route.params.contractManagerId
      }
      if (this.scopeType === 'event-owner') {
        return this.$route.params.eventOwnerId
      }
      return null
    },

    listRouteName() {
      const scopeType = this.$route.meta.scopeType
      const names = {
        'global': 'admin.emailSchedules.list',
        'contract-manager': 'contractManager.emailSchedules.list',
        'event-owner': 'eventOwner.emailSchedules.list',
        'pica-service': 'event.emailSchedules.list'
      }
      return names[scopeType]
    }
  },
  async mounted() {
    await this.setScope({ type: this.scopeType, id: this.scopeId })
  },
  methods: {
    ...mapActions('emailSchedules', ['createEmailSchedule', 'setScope']),

    onClickSave() {
      this.$refs.form.onSave()
    },

    async onSave(data) {
      try {
        await this.createEmailSchedule(data)
        await this.$router.push({ name: this.listRouteName })
        throw new SuccessNotification(
          this.$pgettext('email_schedules', 'Email schedule created successfully!')
        )
      } catch (error) {
        if (error instanceof SuccessNotification) {
          throw error
        }
        // Handle validation errors
        if (error.response && error.response.status === 400) {
          const errors = error.response.data
          if (errors.job_type) {
            this.notifyError(errors.job_type[0])
          } else {
            this.notifyError(this.$pgettext('email_schedules', 'Please check the form for errors'))
          }
        } else {
          this.notifyError(this.$pgettext('email_schedules', 'Failed to create schedule'))
        }
      }
    }
  }
}
</script>

<style scoped>
.main-header {
  margin-bottom: 1.5rem;
}
</style>
